import * as PIXI from 'pixi.js';

export function resetContainer(container: PIXI.Container): void {
  container.visible = true;
  container.alpha = 1;
  container.scale.set(1);
  container.width = 0;
  container.height = 0;
  container.scale.set(1);
  container.position.set(0, 0);
  container.alpha = 1;
  container.rotation = 0;
  container.pivot.set(0, 0);
  container.visible = true;
}

export function resetSprite(sprite: PIXI.Sprite): void {
  resetContainer(sprite);
  sprite.anchor.set(0);
  sprite.texture = PIXI.Texture.EMPTY;
  sprite.blendMode = PIXI.BLEND_MODES.NORMAL;
  sprite.tint = 0xffffff;
}